__turbopack_context__.v({
  "bodyCopy": "_0HAs5W_bodyCopy" + " " + __turbopack_context__.i(515534)["sectionBody"],
  "desktopImage": "_0HAs5W_desktopImage",
  "heading": "_0HAs5W_heading" + " " + __turbopack_context__.i(515534)["sectionHeading"],
  "imageWrapper": "_0HAs5W_imageWrapper",
  "mobileImage": "_0HAs5W_mobileImage",
  "section": "_0HAs5W_section",
  "textContainer": "_0HAs5W_textContainer",
  "tintOverlay": "_0HAs5W_tintOverlay",
});
